export const FETCH_CLEARANCE = 'clearance/FETCH';
export const FETCH_CLEARANCE_SUCCESS = 'clearance/FETCH_SUCCESS';
export const FETCH_CLEARANCE_FAILURE = 'clearance/FETCH_FAILURE';
export const RESET_CLEARANCE = 'clearance/RESET_CLEARANCE';
export const RESET_CLEARANCE_FORM = 'clearance/RESET_CLEARANCE_FORM';
export const FORCE_CLEARANCE_PASS = 'clearance/FORCE_CLEARANCE_PASS';

export const fetchClearance = (data, type, user, person) => {
    return {
        type: FETCH_CLEARANCE,
        value: { data, type, user, person }
    };
};

export const fetchClearanceSuccess = data => {
    return {
        type: FETCH_CLEARANCE_SUCCESS,
        value: data
    };
};

export const fetchClearanceFailure = error => {
    return {
        type: FETCH_CLEARANCE_FAILURE,
        value: error
    };
};

export const resetClearance = () => {
    return {
        type: RESET_CLEARANCE,
        value: null
    };
};

export const resetClearanceForm = () => {
    return {
        type: RESET_CLEARANCE_FORM,
        value: null
    };
};

export const forceClearancePass = () => {
    return {
        type: FORCE_CLEARANCE_PASS,
        value: null
    };
};
